import { render, staticRenderFns } from "./SelectedOptionList.vue?vue&type=template&id=c0d3ec24&scoped=true&"
import script from "./SelectedOptionList.vue?vue&type=script&lang=ts&"
export * from "./SelectedOptionList.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedOptionList.vue?vue&type=style&index=0&id=c0d3ec24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d3ec24",
  null
  
)

export default component.exports